/**
 * © 2024 Little Shilling, Inc.
 * Shon Little
 * Created: 2026-03-15
 */

// Add third-party dependencies.
import { Box } from '@mui/material';

/**
 * TeamBios component.
 * @example
 * return (
 *   <TeamBios />
 * )
 * @returns {React.ReactElement} component.
 */
const TeamBios = () => {
  // Render component.
  return (
    <Box p={0} sx={{ height: 'calc(100vh - 95px)', overflow: 'hidden' }}>
      <Box sx={{ height: '100%', overflow: 'hidden' }}>
        <iframe
          src="https://tools.dance/public/team-bios/releve-studios"
          width="100%"
          height="100%"
          frameBorder="0"
          title="Relevé Studios Team Bios"
          style={{ border: 'none' }}
        />
      </Box>
    </Box>
  );
};

// Export component.
export default TeamBios;
